import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { __ } from '@wordpress/i18n';
import { external } from '@wordpress/icons';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Icon } from '../Icon';
import { Link } from '../Link';
import { VisuallyHidden } from '../VisuallyHidden';
import * as styles from './ExternalLink.styles';
/**
 * @typedef {import('../Link').Props} Props
 */

/**
 *
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'a'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function ExternalLink(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ExternalLink'),
      children = _useContextSystem.children,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children"]);

  return /*#__PURE__*/React.createElement(Link, Object.assign({
    ref: forwardedRef // eslint-disable-next-line react/jsx-no-target-blank
    ,
    target: "_blank"
  }, otherProps), /*#__PURE__*/React.createElement(VisuallyHidden, null, __('(opens in a new tab)')), children, /*#__PURE__*/React.createElement(Icon, {
    className: styles.Icon,
    fill: "currentColor",
    icon: external,
    inline: true,
    size: "15"
  }));
}

export default contextConnect(ExternalLink, 'ExternalLink');